// extracted by mini-css-extract-plugin
export var container = "styles-module--container--zsh0C";
export var content = "styles-module--content--PVozk";
export var image = "styles-module--image--HsIZ7";
export var subtitle = "styles-module--subtitle--bX+CK";
export var textContainer = "styles-module--textContainer--DdS1x";
export var title = "styles-module--title--Ca3FZ";